const withPromise = (func, ...args) =>
  new Promise((resolve, reject) => {
    func(...args, { resolve, reject })
  })

export default withPromise
